import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
// import BasicParagraphPSWorld from './PWSupportingComponents/BasicParagraphPSWorld';
import { onDemandTranslations } from './PWUitls/onDemandTranslations';


const OnDemandAccessButtonSimple = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'OnDemandAccessButtonSimple',
    sourceWeb: 'pslife',
    isCentered: true,
    watchNowButtonText: {
      en: 'go to event',
      es: 'ir al evento',
      ca: "anar a l'esdeveniment",
      pt: 'go to event',
    },
    translations: onDemandTranslations,
    postVideoUrl: '',
    postVideoRole: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const inputHandlerByLanguage = (e, lang = 'en') => {
    const { component } = components[index];
    const { name = '', value = '' } = e.target;

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);
  return (
    <>
      <div className="w-full px-5 rounded-lg bg-greyFilter flex flex-col pt-4 pb-4">
        <div className="bg-greyFilter w-full sm:w-full md:w-full p-4 pl-9">
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black " htmlFor="text">
            <div className="">Watch now text</div>
            {languages.map(lang => (
              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} pb-6px w-full`}>
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black" htmlFor="title">
                  <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1  p-2" onChange={e => inputHandlerByLanguage(e, lang)} name="watchNowButtonText" lang={lang} type="text" value={state.watchNowButtonText[lang.toLowerCase()] || ''} readOnly={reusableComponent && reusableComponent} />
                </label>
              </div>
            ))}
          </label>
        </div>
        <div className="pl-9 w-full">
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="role">
              Source Web
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="sourceWeb" type="text" value={(state && state.sourceWeb) || ''} />
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="role">
              Final Video Role
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="postVideoRole" type="text" value={(state && state.postVideoRole) || ''} />
            </label>
          </div>
          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="url">
              Final Video Url (without https://primaverasound.com)
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="postVideoUrl" type="text" value={(state && state.postVideoUrl) || ''} />
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

OnDemandAccessButtonSimple.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
OnDemandAccessButtonSimple.defaultProps = {
  reusableComponent: null,
};

export default OnDemandAccessButtonSimple;
